<template>
  <div class="c-analyst-assessment-bar-chart">
    <div v-if="legend" class="legend" aria-hidden="true">
      <div class="raised">{{ $t('white-label.components.analystAssessmentBarChart.legend.raised') }}</div>
      <div class="unchanged">{{ $t('white-label.components.analystAssessmentBarChart.legend.unchanged') }}</div>
      <div class="lowered">{{ $t('white-label.components.analystAssessmentBarChart.legend.lowered') }}</div>
    </div>
    <template v-else>
      <span class="sr-only"
        >{{ $t('white-label.components.analystAssessmentBarChart.legend.date') }}{{ data.FINQ }}</span
      >
      <div class="values">
        <div>
          <span class="sr-only">{{ $t('white-label.components.analystAssessmentBarChart.legend.raised') }}</span
          >{{ data.AE_EPS.raised }}
        </div>
        <div>
          <span class="sr-only">{{ $t('white-label.components.analystAssessmentBarChart.legend.unchanged') }}</span
          >{{ data.AE_EPS.unchanged }}
        </div>
        <div>
          <span class="sr-only">{{ $t('white-label.components.analystAssessmentBarChart.legend.lowered') }}</span
          >{{ data.AE_EPS.lowered }}
        </div>
      </div>
      <div class="indicators" v-for="n in rowCount" :key="n" aria-hidden="true">
        <div :class="{ raised: rowCount - n < data.AE_EPS.raised }"></div>
        <div :class="{ unchanged: rowCount - n < data.AE_EPS.unchanged }"></div>
        <div :class="{ lowered: rowCount - n < data.AE_EPS.lowered }"></div>
      </div>
      <div class="date" aria-hidden="true">
        {{ data.FINQ }}
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'c-analyst-assessment-bar-chart',
  props: {
    legend: {
      type: Boolean
    },
    data: {
      type: Object
    },
    rowCount: {
      type: Number,
      default: 8
    }
  }
};
</script>

<style lang="scss">
@import '~@/styles/components/custom/c-analyst-assessment-bar-chart';
</style>
